import { Database, ShieldCheck, Calendar, LayoutGrid, Layers3, Bot, Building2, ChartColumn } from 'lucide-react';

export const governanceSidebarItems = [
  {
    id: 1,
    label: 'Board & Committees',
    disabled: false,
    path: '/Board&Committee',
    icon: Database,
  },
  {
    id: 2,
    label: 'Delegation of Authorities',
    disabled: true,
    path: '#',
    icon: ShieldCheck,
  },
  {
    id: 3,
    label: 'Corporate Calendar',
    disabled: true,
    path: '#',
    icon: Building2,
  },
  {
    id: 4,
    label: 'Governance Framework',
    disabled: true,
    path: '#',
    icon: ChartColumn,
  },
  {
    id: 5,
    label: 'Charters',
    disabled: true,
    path: '#',
    icon: Layers3,
  },
  {
    id: 6,
    label: 'Ai Chatbot',
    disabled: false,
    path: '/chatbot',
    icon: Bot,
  },
];
